import { render, staticRenderFns } from "./DynamicQuestionModal.vue?vue&type=template&id=55767657&"
import script from "./DynamicQuestionModal.vue?vue&type=script&lang=js&"
export * from "./DynamicQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports